export function setUser(token, userType,roleId, customerToken) {
  localStorage.setItem(
    "superAdmin",
    JSON.stringify({
      userToken: token,
      userType: userType,
      customerToken: customerToken,
      roleId:roleId
    })
  );
}
export function getUser() {
  return JSON.parse(localStorage.getItem("superAdmin"));
}
export function signOutUser() {
  localStorage.clear();
}
export function isLoggedIn() {
  const user = getUser();
  if (user !== null) {
    return true;
  } else {
    return false;
  }
}